(() => {
  'use strict';

  const language = (document.documentElement.lang || '').toLowerCase();
  if (!language.startsWith('en')) return;

  const exact = new Map(Object.entries({
    /* HEADER / ANNOUNCEMENTS */
    'YENİ SEZON • COTTON CLUB KOLEKSİYONUNU KEŞFET': 'NEW SEASON • DISCOVER THE COTTON CLUB COLLECTION',
    'Organik Pamuk Seçenekleri – BCI Sertifikalı Pamuklu Parçalar – Güvenli Ödeme – Tişört, Polo Yaka ve Sweatshirt': 'Organic Cotton Options – BCI Certified Cotton Pieces – Secure Payment – T-Shirts, Polo Shirts and Sweatshirts',
    'YENİ SEZON': 'NEW SEASON',
    'Yeni Sezon': 'New Season',
    'Yeni Sezon / 2026': 'New Season / 2026',
    'Cotton Club Koleksiyonları': 'Cotton Club Collections',
    'Koleksiyonları Keşfet': 'Explore Collections',
    'Koleksiyonları keşfet': 'Explore Collections',
    'KADIN': 'WOMEN',
    'Kadın': 'Women',
    'ERKEK': 'MEN',
    'Erkek': 'Men',
    'KOLEKSİYONLAR': 'COLLECTIONS',
    'Koleksiyonlar': 'Collections',
    'TÜM ÜRÜNLER': 'ALL PRODUCTS',
    'Tüm Ürünler': 'All Products',
    'Tüm ürünler': 'All products',
    'Tümünü Gör': 'View All',
    'Tümünü gör': 'View All',
    'Tüm Ürünleri Gör': 'View All Products',
    'TÜMÜNÜ GÖRÜNTÜLE': 'VIEW ALL',
    'Menü': 'Menu',
    'Tümünü görüntüle': 'View all',
    'Arama': 'Search',
    'Hesabım': 'My Account',
    'Sepetim': 'My Cart',
    'Dil seçimi': 'Language selection',
    'Dil seçimini kapat': 'Close language selector',
    'Geri dön': 'Go back',
    'Size en uygun alışveriş deneyimi için dilinizi seçin.': 'Select your language for the best shopping experience.',

    /* CATEGORY NAMES */
    'Atlet': 'Tank Tops',
    'Crop': 'Crop Tops',
    'Tayt': 'Leggings',
    'Tişört': 'T-Shirts',
    'Polo Yaka': 'Polo Shirts',
    'Polo Yaka Tişört': 'Polo Shirts',
    'Ceket': 'Jackets',
    'Pantolon': 'Pants',
    'Eşofman': 'Joggers',
    'Şort': 'Shorts',
    'Hırka': 'Cardigans',
    'Sweatshirt': 'Sweatshirts',

    /* HOMEPAGE HERO */
    'Tüm Ürünlerde Net %20 İndirim Fırsatı': '20% Off All Products',
    'Cotton Club tişört, polo yaka ve sweatshirt modellerini incele. Farklı renk ve kalıp seçenekleri arasından aradığın ürünü bul.': 'Explore Cotton Club T-shirts, polo shirts and sweatshirts. Find the piece that suits you from different colors and fits.',
    'Alışverişe Başla': 'Start Shopping',
    'Organik Pamuk': 'Organic Cotton',
    'BCI Sertifikalı Pamuk': 'BCI Certified Cotton',
    'Kadın, Erkek ve Unisex': 'Women, Men & Unisex',
    '3 Al 2 Öde': 'Buy 3 Pay for 2',
    'Seçili Cotton Club ürünlerinde avantajlı alışverişi keşfedin.': 'Discover special offers on selected Cotton Club products.',

    /* HOMEPAGE CATEGORIES */
    'KATEGORİLER': 'CATEGORIES',
    'Öne Çıkan Kategoriler': 'Featured Categories',
    'En çok tercih edilen kategorilerimizi keşfet, aradığın ürüne hızlıca ulaş.': 'Explore our most popular categories and quickly find what you are looking for.',
    'En çok tercih edilen kategorileri keşfet, aradığın ürüne kolayca ulaş.': 'Explore our most popular categories and easily find what you are looking for.',
    'Ürünleri Gör': 'View Products',
    'Koleksiyonu Gör': 'View Collection',
    'Kadın ve Erkek Tişört Modelleri': "Women's and Men's T-Shirts",
    'Farklı Renk Seçenekleriyle Polo Yaka Modelleri': 'Polo Shirts in Different Colors',
    'Kadın ve Erkek Sweatshirt Modelleri': "Women's and Men's Sweatshirts",
    'Günlük kombinlerin vazgeçilmezi': 'An everyday wardrobe essential',
    'Sade ve zamansız bir görünüm': 'A clean and timeless look',
    'Rahat katmanlar, günlük stil': 'Comfortable layers for everyday style',

    /* BEST SELLERS / FEATURED */
    'ÇOK SATANLAR': 'BEST SELLERS',
    'En çok satanlar': 'Best Sellers',
    'Sezonun öne çıkan Cotton Club parçalarını keşfedin.': 'Discover standout Cotton Club pieces of the season.',
    'SİZİN İÇİN': 'FOR YOU',
    'Öne Çıkan Ürünler': 'Featured Products',
    'Cotton Club koleksiyonundan öne çıkan parçaları incele.': 'Explore featured pieces from the Cotton Club collection.',
    'Cotton Club koleksiyonundan öne çıkan modelleri keşfet.': 'Discover featured styles from the Cotton Club collection.',
    'TÜKENDİ': 'SOLD OUT',
    'Tükendi': 'Sold Out',
    'Sepete Ekle': 'Add to Cart',
    'Sepete Eklendi ✓': 'Added to Cart ✓',
    'Bedenini Seç': 'Select Size',
    'Beden Seç': 'Select Size',
    'Bedeninizi seçin': 'Select your size',
    'Seçenek Seç': 'Select Option',
    'İndirimli Fiyat': 'Sale Price',
    'Ürün seçin': 'Select a product',
    'Shopify panelinden ürün ekleyin': 'Add products from the Shopify admin',

    /* REVIEWS */
    'MÜŞTERİ DENEYİMLERİ': 'CUSTOMER EXPERIENCES',
    'GERÇEK MÜŞTERİ DENEYİMLERİ': 'REAL CUSTOMER EXPERIENCES',
    'Müşterilerimiz ne diyor?': 'What Our Customers Say',
    'Müşterilerimiz Ne Diyor?': 'What Our Customers Say',
    'Müşteri Yorumları': 'Customer Reviews',
    'Değerlendirme yaz': 'Write a Review',

    /* GENDER COLLECTIONS */
    'Kadın, Erkek ve Unisex Ürünler': 'Women, Men & Unisex',
    'Kadın, unisex ve erkek koleksiyonlarında günlük stile uyum sağlayan Cotton Club parçalarını keşfedin.': 'Explore Cotton Club pieces designed for everyday style across women, men and unisex collections.',
    'Kadın Ürünleri': "Women's Collection",
    'Kadın koleksiyonundaki modelleri incele.': "Explore styles from the women's collection.",
    'Erkek Ürünleri': "Men's Collection",
    'Erkek koleksiyonundaki modelleri incele.': "Explore styles from the men's collection.",
    'Unisex Ürünler': 'Unisex Collection',
    'Her stile uyum sağlayan unisex ürünleri keşfet.': 'Discover unisex pieces designed to suit every style.',
    'Keşfet': 'Explore',

    /* SHOPPING TRUST */
    'ALIŞVERİŞ GÜVENCESİ': 'SHOPPING ASSURANCE',
    'Alışverişinizin her adımı açık.': 'Clear information at every step of your order.',
    'Siparişten iadeye kadar ihtiyaç duyabileceğiniz bilgilere kolayca ulaşın.': 'Easily access the information you may need from ordering to returns.',
    'TESLİMAT': 'DELIVERY',
    'Kargo & Teslimat': 'Shipping & Delivery',
    'Sipariş, kargo ve teslimat sürecine ilişkin bilgileri inceleyin.': 'Review information about ordering, shipping and delivery.',
    'DESTEK': 'SUPPORT',
    'İade & Değişim': 'Returns & Exchanges',
    'İade ve değişim koşullarına kolayca ulaşın.': 'Easily access our return and exchange terms.',
    'ÖDEME': 'PAYMENT',
    'Ödeme': 'Payment',
    'Ödeme & Güvenlik': 'Payment & Security',
    'Ödeme sürecine ve mevcut ödeme seçeneklerine ilişkin bilgileri inceleyin.': 'Review information about payment and available payment options.',
    'Detayları Gör': 'View Details',
    'Politikayı İncele': 'View Policy',
    'Ödeme Bilgileri': 'Payment Information',

    /* COLLECTION PAGE */
    '%100 Organik Pamuk Dokusu': '100% Organic Cotton Texture',
    'Pamuk odaklı seçki': 'Cotton-focused selection',
    'Kadın Koleksiyonuna Özel Seçenekler': "Options Selected for Women's Collection",
    'Erkek Koleksiyonuna Özel Seçenekler': "Options Selected for Men's Collection",
    'Unisex Kullanıma Uygun Seçenekler': 'Options for Unisex Wear',
    'Farklı Kalıp ve Renk Alternatifleri': 'Different Fits & Color Options',
    'Farklı Renk Alternatifleri': 'Different Color Options',
    'Farklı Renk Seçenekleri': 'Different Color Options',
    'Farklı Model ve Renk Seçenekleri': 'Different Styles & Color Options',
    'Farklı Renk ve Detay Seçenekleri': 'Different Colors & Details',
    'Farklı Kategori ve Renk Seçenekleri': 'Different Categories & Colors',
    'Farklı Kategori ve Renk Alternatifleri': 'Different Categories & Colors',
    'Günlük Kullanıma Uygun Tasarımlar': 'Designed for Everyday Wear',
    'Günlük Kullanıma Uygun Kesimler': 'Fits for Everyday Wear',
    'Günlük Kullanıma Uygun Kalıplar': 'Fits for Everyday Wear',
    'Günlük ve Aktif Kullanıma Uygun': 'Suitable for Everyday & Active Wear',
    'Günlük Kombinlere Uygun': 'Easy to Style Every Day',
    'Günlük Kombinlere Uyumlu': 'Easy to Style Every Day',
    'Günlük Kombinlere Uyumlu Tasarımlar': 'Designed for Everyday Styling',
    'Nefes Alan Rahat Yapı': 'Breathable & Comfortable',
    'Yumuşak ve Esnek Dokular': 'Soft & Flexible Fabrics',
    'Modern Kısa Kesim': 'Modern Cropped Fit',
    'Esnek ve Hareket Odaklı Yapı': 'Flexible, Movement-Friendly Design',
    'Vücuda Uyumlu Kalıp': 'Body-Contouring Fit',
    'Vücuda Uyum Sağlayan Kesimler': 'Body-Contouring Fits',
    'Katmanlı Kullanıma Uygun': 'Ideal for Layering',
    'Katmanlı Kombinlere Uygun': 'Ideal for Layering',
    'Tek Başına veya Katmanlı Kullanım': 'Wear Alone or Layered',
    'Rahat ve Modern Kalıplar': 'Comfortable Modern Fits',
    'Rahat Günlük Kalıplar': 'Comfortable Everyday Fits',
    'Rahat Hareket Alanı': 'Freedom of Movement',
    'Farklı Kesim Alternatifleri': 'Different Fit Options',
    'Konfor Odaklı Kalıp': 'Comfort-Focused Fit',
    'Konfor Odaklı Kullanım': 'Comfort-Focused Design',
    'Rahat ve Yumuşak Kullanım': 'Soft & Comfortable Feel',
    'Rahat Günlük Kullanım': 'Comfortable Everyday Wear',
    'Polo Yaka Detayı': 'Polo Collar Detail',
    'Unisex Kullanıma Uygun Kalıplar': 'Fits Designed for Unisex Wear',
    'Unisex Rahat Kalıplar': 'Comfortable Unisex Fits',
    'Rahat Unisex Kalıplar': 'Comfortable Unisex Fits',
    'Koleksiyona Özel Ürün Seçkisi': 'Collection-Specific Product Selection',
    'Koleksiyona Özel Tişört Seçkisi': 'Collection T-Shirt Selection',
    'Koleksiyona Özel Polo Yaka Seçkisi': 'Collection Polo Shirt Selection',
    'Koleksiyona Özel Sweatshirt Seçkisi': 'Collection Sweatshirt Selection',
    'I Wasn’t Here Koleksiyon Seçkisi': "I Wasn't Here Collection Selection",
    'Here I Am Koleksiyon Seçkisi': 'Here I Am Collection Selection',
    'I Am Patch Koleksiyon Seçkisi': 'I Am Patch Collection Selection',
    'Sezona Özel Ürün Seçkisi': 'Seasonal Product Selection',
    'Cotton Club Koleksiyon Seçkileri': 'Cotton Club Collection Selections',
    'Koleksiyona Göre Kolay Keşif': 'Easy Discovery by Collection',
    'Tüm Cotton Club Ürünleri Bir Arada': 'All Cotton Club Products in One Place',
    'Koleksiyon Bilgisi': 'Collection Information',
    'Toplam Ürün': 'Total Products',
    'Kategori': 'Category',
    'Vurgu': 'Highlight',
    'Filtreleri Aç': 'Open Filters',
    'Filtrele': 'Filter',
    'Sırala': 'Sort',
    'Ürün görünümü': 'Product view',
    'Sonuç bulunamadı.': 'No results found.',
    'Aradığınız filtrelerle eşleşen ürün yok.': 'No products match the selected filters.',
    'Tüm ürünleri göster': 'Show All Products',
    'Önceki sayfa': 'Previous page',
    'Ürünleri daralt': 'Filter Products',
    'Ana Sayfa': 'Home',

    /* FINAL COLLECTION / UI CLEANUP */
    'Alt Kategoriler': 'Subcategories',
    'ALT KATEGORİLER': 'SUBCATEGORIES',
    'Kadın, Erkek ve Unisex Seçenekler': 'Women, Men & Unisex Options',
    'Fitilli ve Rahat Dokular': 'Ribbed & Comfortable Fabrics',
    'Günlük Kombinleri Tamamlayan Tasarımlar': 'Styles to Complete Everyday Outfits',
    'Günlük Kullanıma Uygun': 'Suitable for Everyday Wear',
    'Günlük Kullanıma Uygun Modeller': 'Styles for Everyday Wear',
    'Günlük Kullanıma Uygun Parçalar': 'Pieces for Everyday Wear',
    'Birbiriyle Uyumlu Günlük Parçalar': 'Coordinated Everyday Pieces',
    'Farklı Model ve Renk Alternatifleri': 'Different Style & Color Options',
    'Farklı Renk ve Detay Alternatifleri': 'Different Color & Detail Options',
    'Koleksiyona Özel Parçalar': 'Collection-Specific Pieces',

    /* SEARCH / MOBILE HEADER */
    'Ara': 'Search',
    'Sepet': 'Cart',
    'Ne aramıştınız?': 'What are you looking for?',
    'Ürün adı, model veya ürün kodu ile arama yapabilirsiniz.': 'Search by product name, model or product code.',
    'Örn. polo yaka, 1010720...': 'e.g. polo shirt, 1010720...',
    'ARA': 'SEARCH',

    /* CART DRAWER */
    'Sepete Git': 'Go to Cart',
    'Alışverişe Devam Et': 'Continue Shopping',
    'Tebrikler! Ücretsiz Kargo Fırsatından Yararlandınız!': 'Congratulations! You’ve Unlocked Free Shipping!',
    'Ara toplam': 'Subtotal',
    'Ara toplam:': 'Subtotal:',

    /* FILTER / PRODUCT UI */
    'Filtreler': 'Filters',
    'Filtreleri temizle': 'Clear Filters',
    'Ürünü Sepete Ekle': 'Add Product to Cart',
    'Uygula': 'Apply',
    'Temizle': 'Clear',
    'Maks': 'Max',
    'Nefes alan': 'Breathable',
    'Kaliteli Kumaş Yapısı': 'Quality Fabric Structure',
    'Bedenini Bul': 'Find Your Size',
    'SEPETTEKİ FİYAT': 'CART PRICE',
    'Ürün & Alışveriş Güvencesi': 'Product & Shopping Assurance',
    'ÖLÇÜ REHBERİ': 'SIZE GUIDE',
    'Sepete Eklendi': 'Added to Cart',
    'Ekleniyor...': 'Adding...',
    'Ürün sepete eklenemedi.': 'Product could not be added to cart.',
    'Henüz değerlendirme yok': 'No reviews yet',

    /* COLLECTION-SPECIFIC COPY MISSED BY THE ORIGINAL DICTIONARY */
    'Seçili Cotton Club koleksiyonuna ait polo yaka modellerini farklı renk ve detay seçenekleriyle keşfedin. Koleksiyonun polo yaka parçalarını bir arada inceleyin.': 'Explore polo styles from the selected Cotton Club collection in different colors and details. Discover the collection’s polo pieces in one place.',
    'Seçili Cotton Club koleksiyonuna ait tişört modellerini farklı renk ve detay seçenekleriyle keşfedin. Koleksiyonun tişört parçalarını bir arada inceleyin.': 'Explore T-shirts from the selected Cotton Club collection in different colors and details. Discover the collection’s T-shirt pieces in one place.',
    'Seçili Cotton Club koleksiyonuna ait sweatshirt modellerini farklı renk, kesim ve detay seçenekleriyle keşfedin. Koleksiyonun sweatshirt parçalarını bir arada inceleyin.': 'Explore sweatshirts from the selected Cotton Club collection in different colors, fits and details. Discover the collection’s sweatshirt pieces in one place.',
    'Seçili Cotton Club koleksiyonunun ürünlerini farklı renk, model ve kategori seçenekleriyle keşfedin. Koleksiyona ait parçaları bir arada inceleyin.': 'Explore products from the selected Cotton Club collection in different colors, styles and categories. Discover all pieces from the collection in one place.',
    'Cotton Club I Wasn’t Here koleksiyonunu farklı kategori, renk ve model seçenekleriyle keşfedin. Koleksiyona ait günlük parçaları tek bir sayfada bir arada inceleyin.': 'Explore the Cotton Club I Wasn’t Here collection across different categories, colors and styles. Discover its everyday pieces together on one page.',
    'Cotton Club Here I Am koleksiyonuna ait modelleri farklı renk ve ürün seçenekleriyle keşfedin. Koleksiyondaki günlük parçaları bir arada inceleyin.': 'Explore styles from the Cotton Club Here I Am collection in different colors and product options. Discover its everyday pieces in one place.',
    'Cotton Club I Am Patch koleksiyonuna ait modelleri farklı renk ve detay seçenekleriyle keşfedin. Koleksiyonun karakteristik parçalarını bir arada inceleyin.': 'Explore styles from the Cotton Club I Am Patch collection in different colors and details. Discover the collection’s signature pieces in one place.',
    'Cotton Club Happy New Year seçkisindeki sezonluk modelleri farklı renk ve ürün alternatifleriyle keşfedin. Koleksiyona ait parçaları bir arada inceleyin.': 'Explore seasonal styles from the Cotton Club Happy New Year selection in different colors and product options. Discover the collection pieces in one place.',
    'Cotton Club koleksiyonlarını farklı model, renk ve kategori seçenekleriyle keşfedin. Her koleksiyona ait ürünleri kendi seçkisi içinde kolayca inceleyin.': 'Explore Cotton Club collections across different styles, colors and categories. Easily discover products within each collection’s own selection.',

    /* COLLECTION DESCRIPTIONS */
    'Cotton Club kadın koleksiyonunda atlet, crop, tayt, tişört, ceket, pantolon, eşofman, hırka ve sweatshirt modellerini bir arada keşfedin. Farklı kesim ve renk seçenekleri arasından günlük stilinize uygun parçaları inceleyin.': "Explore tank tops, crop tops, leggings, T-shirts, jackets, pants, joggers, cardigans and sweatshirts in the Cotton Club women's collection. Discover pieces for your everyday style in different fits and colors.",
    'Cotton Club kadın atlet modellerini farklı renk ve kesim seçenekleriyle keşfedin. Tek başına veya katmanlı kombinlerde kullanabileceğiniz günlük parçaları bir arada inceleyin.': "Explore Cotton Club women's tank tops in different colors and fits. Discover everyday pieces to wear alone or layered.",
    'Cotton Club kadın crop modellerini modern kısa kesimler ve farklı renk alternatifleriyle keşfedin. Günlük kombinlere kolayca uyum sağlayan crop seçeneklerini bir arada inceleyin.': "Explore Cotton Club women's crop tops with modern cropped fits and different color options. Discover styles that easily fit into everyday outfits.",
    'Cotton Club kadın tayt modellerini hareket rahatlığı ve günlük kullanım odağında keşfedin. Vücuda uyum sağlayan kesimler ve farklı renk seçenekleri arasından stilinize uygun modeli seçin.': "Explore Cotton Club women's leggings designed for freedom of movement and everyday wear. Choose from body-contouring fits and different colors.",
    'Cotton Club kadın tişört modellerini rahat kesimler ve farklı renk seçenekleriyle keşfedin. Günlük gardıroba kolayca uyum sağlayan tişört alternatiflerini bir arada inceleyin.': "Explore Cotton Club women's T-shirts in comfortable fits and different colors. Discover versatile T-shirts for your everyday wardrobe.",
    'Cotton Club kadın ceket modellerini günlük kombinlere uyum sağlayan rahat ve modern kesimlerle keşfedin. Farklı renk seçenekleriyle katmanlı kullanıma uygun parçaları inceleyin.': "Explore Cotton Club women's jackets with comfortable modern fits for everyday outfits. Discover layer-friendly pieces in different colors.",
    'Cotton Club kadın pantolon modellerini farklı kesim ve renk alternatifleriyle keşfedin. Günlük kombinlerde rahat kullanım sunan pantolon seçeneklerini bir arada inceleyin.': "Explore Cotton Club women's pants in different fits and colors. Discover comfortable options for everyday styling.",
    'Cotton Club kadın eşofman modellerini günlük ve aktif kullanıma uygun rahat kalıplarla keşfedin. Konfor odaklı kesimler ve farklı renk seçenekleri arasından size uygun modeli inceleyin.': "Explore Cotton Club women's joggers in comfortable fits for everyday and active wear. Find your style among comfort-focused cuts and different colors.",
    'Cotton Club kadın hırka modellerini katmanlı kullanıma uygun rahat seçeneklerle keşfedin. Günlük kombinlerinizi tamamlayacak farklı renk ve model alternatiflerini bir arada inceleyin.': "Explore Cotton Club women's cardigans designed for comfortable layering. Discover different colors and styles to complete everyday outfits.",
    'Cotton Club kadın sweatshirt modellerini rahat kalıplar ve farklı renk seçenekleriyle keşfedin. Günlük kullanıma uygun sweatshirt alternatifleri arasından stilinize uygun parçayı seçin.': "Explore Cotton Club women's sweatshirts in comfortable fits and different colors. Choose an everyday sweatshirt that suits your style.",
    'Cotton Club erkek koleksiyonunda tişört, polo yaka tişört, atlet, pantolon, eşofman, şort, hırka ve sweatshirt modellerini keşfedin. Günlük kullanıma uyum sağlayan farklı kesim ve renk seçeneklerini bir arada inceleyin.': "Explore T-shirts, polo shirts, tank tops, pants, joggers, shorts, cardigans and sweatshirts in the Cotton Club men's collection. Discover different fits and colors designed for everyday wear.",
    'Cotton Club erkek polo yaka tişört modellerini günlük stile uyum sağlayan farklı renk ve kalıp seçenekleriyle keşfedin. Polo yaka detayını rahat kullanımla buluşturan modelleri inceleyin.': "Explore Cotton Club men's polo shirts in different colors and fits for everyday style. Discover comfortable styles with classic polo collar details.",
    'Cotton Club erkek tişört modellerini günlük kullanıma uygun kesimler ve farklı renk seçenekleriyle keşfedin. Kolay kombinlenen tişört alternatiflerini bir arada inceleyin.': "Explore Cotton Club men's T-shirts in everyday fits and different colors. Discover versatile styles that are easy to combine.",
    'Cotton Club erkek atlet modellerini sade ve rahat kullanım odağında keşfedin. Tek başına veya katmanlı kombinlerde değerlendirebileceğiniz farklı renk seçeneklerini inceleyin.': "Explore Cotton Club men's tank tops designed for simple, comfortable wear. Discover different colors to wear alone or layered.",
    'Cotton Club erkek pantolon modellerini rahat hareket alanı sunan farklı kesim ve renk seçenekleriyle keşfedin. Günlük kombinlere kolayca uyum sağlayan pantolonları inceleyin.': "Explore Cotton Club men's pants in different fits and colors designed for easy movement. Discover versatile styles for everyday outfits.",
    'Cotton Club erkek eşofman modellerini konfor ve hareket rahatlığı odağında keşfedin. Günlük ve aktif kullanıma uyum sağlayan farklı renk ve kalıp seçeneklerini inceleyin.': "Explore Cotton Club men's joggers designed for comfort and easy movement. Discover different colors and fits for everyday and active wear.",
    'Cotton Club erkek şort modellerini rahat günlük kullanım ve hareket özgürlüğü odağında keşfedin. Farklı renk ve kesim seçenekleri arasından stilinize uygun modeli inceleyin.': "Explore Cotton Club men's shorts designed for everyday comfort and freedom of movement. Find your style among different colors and fits.",
    'Cotton Club erkek hırka modellerini günlük kombinlerde katmanlı kullanıma uygun seçeneklerle keşfedin. Rahat kesim ve farklı renk alternatiflerini bir arada inceleyin.': "Explore Cotton Club men's cardigans designed for comfortable everyday layering. Discover relaxed fits and different color options.",
    'Cotton Club erkek sweatshirt modellerini günlük kullanıma uygun rahat kalıplarla keşfedin. Farklı model ve renk seçenekleri arasından gardırobunuza uygun parçayı seçin.': "Explore Cotton Club men's sweatshirts in comfortable everyday fits. Choose from different styles and colors for your wardrobe.",
    'Cotton Club unisex koleksiyonunda tişört, polo yaka, hırka ve sweatshirt modellerini keşfedin. Farklı stillere kolayca uyum sağlayan renk ve kalıp seçeneklerini bir arada inceleyin.': 'Explore T-shirts, polo shirts, cardigans and sweatshirts in the Cotton Club unisex collection. Discover colors and fits designed to suit different styles.',
    'Cotton Club unisex polo yaka modellerini farklı renk seçenekleri ve günlük kullanıma uygun kalıplarla keşfedin. Polo yaka detayını sade bir görünümle buluşturan seçenekleri inceleyin.': 'Explore Cotton Club unisex polo shirts in different colors and everyday fits. Discover clean styles with classic polo collar details.',
    'Cotton Club unisex tişört modellerini farklı renk, baskı ve detay seçenekleriyle keşfedin. Günlük stile kolayca uyum sağlayan rahat tişört alternatiflerini bir arada inceleyin.': 'Explore Cotton Club unisex T-shirts in different colors, prints and details. Discover comfortable styles designed for everyday wear.',
    'Cotton Club unisex hırka modellerini katmanlı kullanıma uygun rahat seçeneklerle keşfedin. Farklı renk alternatifleriyle günlük kombinlerinizi tamamlayacak modelleri inceleyin.': 'Explore Cotton Club unisex cardigans designed for comfortable layering. Discover different colors to complete everyday outfits.',
    'Cotton Club unisex sweatshirt modellerini farklı kesim, renk ve detay seçenekleriyle keşfedin. Günlük kullanıma uyum sağlayan rahat sweatshirt alternatiflerini bir arada inceleyin.': 'Explore Cotton Club unisex sweatshirts in different fits, colors and details. Discover comfortable options for everyday wear.',
    'Cotton Club ürünlerini kadın, erkek ve unisex seçenekleriyle bir arada keşfedin. Farklı kategori, model, renk ve kalıp alternatifleri arasından stilinize uygun parçaları inceleyin.': 'Explore Cotton Club products across women, men and unisex collections. Discover pieces that suit your style from different categories, colors and fits.',

    /* PRODUCT PAGE */
    'Ürün Detayları': 'Product Details',
    'Kumaş & Materyal': 'Fabric & Material',
    'Bakım & Yıkama': 'Care & Washing',
    'Kargo & İade': 'Shipping & Returns',
    'Pamuk Kalitesi': 'Cotton Quality',
    'Doğal, nefes alan ve kaliteli pamuklu kumaş yapısı.': 'Natural, breathable and quality cotton fabric.',
    'Doğal': 'Natural',
    'Yumuşak doku': 'Soft texture',
    'Bugün Kargoda': 'Ships Today',
    "14:00'a kadar sipariş ver": 'Order by 2:00 PM',
    'Yarın Kargoda': 'Ships Tomorrow',
    'Bugünkü gönderim süresi sona erdi': "Today's dispatch window has ended",
    'Kalan süre': 'Time remaining',
    'Tahmini teslimat: 1–3 iş günü': 'Estimated delivery: 1–3 business days',
    'COTTON CLUB · ÖLÇÜ REHBERİ': 'COTTON CLUB · SIZE GUIDE',
    'Ölçüler santimetre (cm) cinsindendir. İki beden arasında kalıyorsanız kullanım tercihinize göre seçim yapabilirsiniz.': 'Measurements are in centimeters (cm). If you are between two sizes, choose according to your preferred fit.',
    'Beden tablosu içeriği yakında eklenecektir.': 'The size guide will be added soon.',
    'Beden Tablosu': 'Size Guide',
    'Beden': 'Size',
    'BEDEN': 'SIZE',
    'Renk': 'Color',
    'RENK': 'COLOR',
    'Kalıp': 'Fit',
    'Kumaş': 'Fabric',
    'ÜRÜN & ALIŞVERİŞ GÜVENCESİ': 'PRODUCT & SHOPPING ASSURANCE',
    'Kumaş içeriği ve ürün detaylarını inceleyin.': 'Review fabric composition and product details.',
    'Kolay İade & Değişim': 'Easy Returns & Exchanges',
    'İade koşullarını inceleyin.': 'Review return conditions.',
    'Güvenli Ödeme': 'Secure Payment',
    'Güvenli ödeme': 'Secure payment',
    'Güvenli ödeme altyapısı.': 'Secure payment infrastructure.',
    'Hızlı Teslimat': 'Fast Delivery',
    'Siparişiniz hazırlık sonrası kargoya teslim edilir.': 'Your order is handed over to the carrier after preparation.',
    'Stokta': 'In Stock',
    'Stokta yok': 'Out of Stock',
    'Benzer Ürünler': 'You May Also Like',
    'STİLİNİ TAMAMLA': 'COMPLETE THE LOOK',

    /* FOOTER */
    'Günlük stile odaklanan, kumaş ve kullanım konforunu önemseyen Cotton Club koleksiyonlarını keşfedin.': 'Discover Cotton Club collections focused on everyday style, fabric quality and comfort.',
    'Bize Ulaşın': 'Contact Us',
    'İletişim': 'Contact',
    'Hakkımızda': 'About Us',
    'Sıkça Sorulan Sorular': 'Frequently Asked Questions',
    'Kargo Politikası': 'Shipping Policy',
    'İade Politikası': 'Return Policy',
    'Gizlilik Politikası': 'Privacy Policy',
    'Kullanım Koşulları': 'Terms of Service',
    'Gizlilik ve Güvenlik': 'Privacy & Security',
    'KVKK Aydınlatma Metni': 'Data Protection Notice',
    'Mesafeli Satış Sözleşmesi': 'Distance Sales Agreement',
    'Üyelik Sözleşmesi': 'Membership Agreement',
    'Satış Koşulları': 'Terms of Sale',
    'Ürün Ara': 'Search Products',
    'Tüm hakları saklıdır.': 'All rights reserved.',
    'tarafından özenle hazırlanmıştır.': 'carefully crafted by',
    'Ödeme yöntemleri': 'Payment methods',
    'İletişim bilgileri': 'Contact information',
    'Sosyal medya bağlantıları': 'Social media links',

    /* CONTACT / FAQ / CERTIFICATES / SHIPPING / RETURNS */
    'SIKÇA SORULAN SORULAR': 'FREQUENTLY ASKED QUESTIONS',
    'Sipariş, ürün, kargo ve iade süreçleriyle ilgili sık sorulan soruların yanıtlarını burada bulabilirsiniz.': 'Find answers to frequently asked questions about orders, products, shipping and returns.',
    'Aradığınız yanıtı bulamadınız mı?': "Couldn't find the answer you were looking for?",
    'Bizimle İletişime Geçin': 'Contact Us',
    'SERTİFİKALAR': 'CERTIFICATES',
    'Cotton Club ürünleriyle ilgili sertifika ve belgeleri aşağıda inceleyebilirsiniz.': 'You can review certificates and documents related to Cotton Club products below.',
    'Sertifikaların kapsamı belgeye ve ilgili ürün grubuna göre değişebilir.': 'Certificate coverage may vary by document and related product group.',
    'Mesaj Gönderin': 'Send a Message',
    'Aşağıdaki formu doldurarak bize doğrudan mesaj gönderebilirsiniz.': 'Fill out the form below to send us a message directly.',
    'Mesajı Gönder': 'Send Message',
    'Sipariş, ürün, teslimat veya diğer konulardaki sorularınız için bizimle iletişime geçebilirsiniz.': 'Contact us with questions about orders, products, delivery or anything else.',
    'Sipariş, ürün ve teslimat konularındaki sorularınız için bize ulaşabilirsiniz.': 'Contact us with questions about orders, products and delivery.',
    'KARGO & TESLİMAT': 'SHIPPING & DELIVERY',
    'Siparişinizin hazırlanmasından teslimatına kadar kargo süreciyle ilgili temel bilgileri burada bulabilirsiniz.': 'Find essential information about the shipping process from order preparation to delivery.',
    'Siparişlerin Hazırlanması': 'Order Preparation',
    'Kargo Takibi': 'Shipment Tracking',
    'Kargo Ücreti': 'Shipping Cost',
    'Teslimat': 'Delivery',
    'Siparişinizle ilgili desteğe mi ihtiyacınız var?': 'Need help with your order?',
    'İADE & DEĞİŞİM': 'RETURNS & EXCHANGES',
    'İade ve değişim talepleriniz için geçerli temel koşulları ve işlem adımlarını burada inceleyebilirsiniz.': 'Review the basic terms and steps for return and exchange requests.',
    'İade Koşulları': 'Return Conditions',
    'İade Talebinin Başlatılması': 'Starting a Return Request',
    'Kontrol ve Ücret İadesi': 'Inspection & Refund',
    'Beden veya Renk Değişimi': 'Size or Color Exchange',
    'İade Edilemeyen Ürünler': 'Non-Returnable Products',
    '30 GÜN': '30 DAYS',
    'Ürünü teslim aldığınız tarihten itibaren iade veya değişim talebinde bulunabilirsiniz.': 'You may request a return or exchange within 30 days of receiving your order.',
    'İade veya değişim talebi başlatmak mı istiyorsunuz?': 'Would you like to start a return or exchange request?',

    /* FAQ QUESTIONS */
    'Siparişimi nasıl verebilirim?': 'How can I place an order?',
    'Hangi ödeme yöntemlerini kullanabilirim?': 'Which payment methods can I use?',
    'Siparişimin durumunu nasıl takip edebilirim?': 'How can I track my order?',
    'Kargo ve teslimat koşullarını nereden öğrenebilirim?': 'Where can I find shipping and delivery information?',
    'İade veya değişim işlemini nasıl yapabilirim?': 'How can I return or exchange an item?',
    'Doğru beden ve kalıbı nasıl seçebilirim?': 'How do I choose the right size and fit?',
    'Tüm ürünler organik pamuk veya BCI sertifikalı mı?': 'Are all products organic cotton or BCI certified?',
    'Stokta olmayan beden veya renkleri seçebilir miyim?': 'Can I select sizes or colors that are out of stock?',
    'Ürünlerin bakım ve yıkama bilgilerini nereden görebilirim?': 'Where can I find care and washing instructions?',
    'Cotton Club ile nasıl iletişime geçebilirim?': 'How can I contact Cotton Club?',

    /* LEGACY PROMOS THAT MAY STILL RENDER */
    '🔥 3 AL 2 ÖDE - Kaçırma!': '🔥 BUY 3 PAY FOR 2 - Don\'t Miss Out!',
    '🔥 2.Üründe Geçerli %30 İndirim - Kaçırma!': '🔥 30% OFF THE 2ND ITEM - Don\'t Miss Out!',
    'İndirim sona erdi!': 'The offer has ended!',
    '🚚 Tüm Siparişlerde Ücretsiz Kargo': '🚚 Free Shipping on All Orders',
    '🎁 Yeni Üyelere Özel %10 İndirim Kuponu (YENIUYE10)': '🎁 10% Discount for New Members (YENIUYE10)',
    'Hızlı Bağlantılar': 'Quick Links',
    'Özel ürün lansmanları ve benzersiz deneyimler kazanmak için kaydolun.': 'Sign up for exclusive product launches and unique experiences.',
    'Sipariş Özeti': 'Order Summary',
    'EN ÇOK SATANLAR': 'BEST SELLERS',
    'Daha fazla bİlgİ edİnİn': 'Learn More',
    '%100 Güvenli Ödeme': '100% Secure Payment',
    'Cotton Club yeni sezon koleksiyonu': 'Cotton Club new season collection',
    'Teslimat koşullarını inceleyin.': 'Review delivery terms.',
    'İade ve değişim koşullarını inceleyin.': 'Review return and exchange terms.',
    'Kullanılabilir ödeme seçeneklerini inceleyin.': 'Review available payment options.',
    'Organik pamuk odaklı koleksiyonumuzu keşfedin. Nefes alan dokular, modern kalıplar ve gün boyu konfor sunan parçaları bir arada inceleyin.': 'Explore our cotton-focused collection with breathable fabrics, modern fits and pieces designed for all-day comfort.',
    'Gün Boyu Konfor Sunan Kalıplar': 'Fits Designed for All-Day Comfort',
    'Güvenli Ödeme ve Hızlı Kargo': 'Secure Payment & Fast Shipping',
    'Yakından Gör': 'View Up Close',
    'Daha Fazla Ürün': 'More Products',
    'ÜRÜN BİLGİLERİ': 'PRODUCT INFORMATION',
    'Ürün materyal özellikleri': 'Product material features',
    'Önceki görsel': 'Previous image',
    'Sonraki görsel': 'Next image',
    'Ürün görselini büyüt': 'Enlarge product image',
    'Adedi artır': 'Increase quantity',
    'Adedi azalt': 'Decrease quantity',
    'Görseli kapat': 'Close image',
    'Önceki ürün görseli': 'Previous product image',
    'Sonraki ürün görseli': 'Next product image',
    'Kapat': 'Close',
    'değerlendirme': 'reviews',
    'Bu alana içerik veya dinamik ürün verisi bağlayın.': 'Add content or dynamic product data to this area.',
    'Kadın Atlet': "Women's Tank Tops",
    'Kadın Crop': "Women's Crop Tops",
    'Kadın Tayt': "Women's Leggings",
    'Kadın Tişört': "Women's T-Shirts",
    'Kadın Ceket': "Women's Jackets",
    'Kadın Pantolon': "Women's Pants",
    'Kadın Eşofman': "Women's Joggers",
    'Kadın Hırka': "Women's Cardigans",
    'Kadın Sweatshirt': "Women's Sweatshirts",
    'Erkek Atlet': "Men's Tank Tops",
    'Erkek Tişört': "Men's T-Shirts",
    'Erkek Polo Yaka Tişört': "Men's Polo Shirts",
    'Erkek Pantolon': "Men's Pants",
    'Erkek Eşofman': "Men's Joggers",
    'Erkek Şort': "Men's Shorts",
    'Erkek Hırka': "Men's Cardigans",
    'Erkek Sweatshirt': "Men's Sweatshirts",
    'Unisex Tişört': 'Unisex T-Shirts',
    'Unisex Polo Yaka': 'Unisex Polo Shirts',
    'Unisex Hırka': 'Unisex Cardigans',
    'Unisex Sweatshirt': 'Unisex Sweatshirts',
    '3–7 iş günü': '3–7 business days',
    'e-posta veya SMS': 'email or SMS',
    'tüm siparişlerde ücretsiz kargo': 'free shipping on all orders',
    'en geç 10 iş günü': 'within 10 business days',
    'Ödeme onayı alınan siparişler hazırlanarak': 'Orders with confirmed payment are prepared and',
    'içerisinde kargoya teslim edilir. Kampanya dönemlerinde yoğunluğa bağlı olarak bu süre değişiklik gösterebilir.': 'handed over to the carrier within this period. Processing times may vary during promotional periods due to high demand.',
    'Siparişiniz kargoya teslim edildiğinde kargo takip bilgileriniz kayıtlı iletişim bilgileriniz üzerinden': 'Once your order is handed over to the carrier, tracking information will be sent to your registered contact details via',
    'ile paylaşılır.': 'and shared with you.',
    'Şu anda Cotton Club alışverişlerinde': 'Currently, Cotton Club orders include',
    'uygulanmaktadır. Kampanya veya kargo koşullarında değişiklik olması halinde güncel bilgi sepet ve ödeme adımlarında gösterilir.': 'The latest information will be shown in the cart and checkout if promotional or shipping conditions change.',
    'Siparişler, ödeme sırasında belirttiğiniz teslimat adresine anlaşmalı kargo firması aracılığıyla gönderilir. Teslimat sırasında paketinizde belirgin bir hasar görmeniz halinde kargo görevlisiyle birlikte durumu kontrol etmenizi öneririz.': 'Orders are shipped to the delivery address provided at checkout via our contracted carrier. If you notice visible package damage at delivery, we recommend checking it together with the courier.',
    'Kampanya dönemleri, resmi tatiller veya kargo operasyonlarındaki yoğunluklar teslimat sürelerinde değişikliğe neden olabilir.': 'Promotional periods, public holidays or high carrier volumes may affect delivery times.',
    'İade edilecek ürünün': 'The item being returned must be',
    'kullanılmamış, yıkanmamış, etiketleri çıkarılmamış ve orijinal ambalajında': 'unused, unwashed, with tags attached and in its original packaging',
    'olması gerekir. Ürünle birlikte varsa fatura veya e-fatura çıktısının da gönderilmesi önerilir.': 'A copy of the invoice or e-invoice, if available, is also recommended with the return.',
    'İade talebinizi sipariş numaranızla birlikte müşteri hizmetlerimize iletebilirsiniz. Talebiniz onaylandıktan sonra iade gönderimi için gerekli kargo bilgileri sizinle paylaşılır.': 'You can submit your return request to customer service with your order number. Once approved, the necessary return shipping information will be shared with you.',
    'İade edilen ürün depomuza ulaştıktan sonra': 'Once the returned item reaches our warehouse, it is inspected within',
    'içerisinde kontrol edilir. Onaylanan iadelerde ödeme, alışverişte kullanılan ödeme yöntemiyle': 'Approved refunds are issued to the original payment method',
    'içerisinde iade edilir.': 'after approval.',
    'Stok durumuna bağlı olarak farklı beden veya renk için değişim talep edebilirsiniz. İstenen seçenek stokta bulunmuyorsa değişim yerine ücret iadesi uygulanabilir.': 'Subject to stock availability, you may request an exchange for a different size or color. If the requested option is unavailable, a refund may be issued instead.',
    'Kullanılmış, yıkanmış, etiketi çıkarılmış, hasar görmüş veya orijinal formunu kaybetmiş ürünler iade kapsamına alınmaz. Kişiye özel üretilen ürünler ile hijyen nedeniyle iadesi uygun olmayan ürünler de kapsam dışında olabilir.': 'Used, washed, damaged items, items without tags or items that have lost their original form are not eligible for return. Personalized or hygiene-sensitive products may also be excluded.',
    'Kredi kartı ve banka kaynaklı iade yansıtma süreleri bankaya göre değişiklik gösterebilir.': 'The time it takes for a refund to appear may vary depending on your bank or card provider.',
    'Beğendiğiniz üründe mevcut renk ve beden seçeneklerini belirledikten sonra ürünü sepete ekleyebilir ve ödeme adımlarını takip ederek siparişinizi tamamlayabilirsiniz.': 'Choose the available color and size for the product you like, add it to your cart and follow the checkout steps to complete your order.',
    'Mağazamızda aktif olan güncel ödeme seçeneklerini ödeme adımında görebilirsiniz. Ödeme seçenekleri zaman içinde değişebileceği için en güncel bilgi ödeme ekranında yer alır.': 'You can see the currently available payment methods during checkout. As payment options may change, the checkout page always shows the latest information.',
    'Siparişinizle ilgili güncel bilgileri sipariş sürecinde tarafınıza iletilen bildirimlerden takip edebilirsiniz. Desteğe ihtiyaç duyarsanız İletişim sayfamızdan bize ulaşabilirsiniz.': 'You can track order updates through the notifications sent during the order process. If you need assistance, contact us through our Contact page.',
    'Güncel kargo, hazırlık ve teslimat koşullarını Kargo & Teslimat sayfamızdan inceleyebilirsiniz. Siparişe özel bir sorunuz varsa müşteri hizmetlerimizle iletişime geçebilirsiniz.': 'You can review current shipping, preparation and delivery terms on our Shipping & Delivery page. Contact customer service if you have a question about a specific order.',
    'İade ve değişim sürecine ilişkin güncel koşullar ve izlenecek adımlar İade & Değişim sayfamızda yer alır. İşlem öncesinde bu sayfadaki koşulları incelemenizi öneririz.': 'Current return and exchange terms and steps are available on our Returns & Exchanges page. We recommend reviewing them before starting a request.',
    'Ürün adı ve ürün detaylarında belirtilen kalıp bilgilerini kontrol edebilirsiniz. Standart, rahat veya oversize gibi kalıp özellikleri ürüne göre değişebilir. Kararsız kaldığınız bir model için bize ulaşabilirsiniz.': 'Check the fit information in the product name and details. Standard, relaxed and oversized fits may vary by product. Contact us if you need help choosing a style.',
    'Hayır. Kumaş ve sertifika özellikleri ürüne göre değişebilir. Organik pamuk veya BCI sertifikalı pamuk kullanılan seçeneklerde bu bilgi ürün adı veya ürün detaylarında ayrıca belirtilir.': 'No. Fabric and certification details vary by product. Organic cotton or BCI certified cotton is specifically stated in the product name or details where applicable.',
    'Stokta bulunmayan seçenekler ürün sayfasında seçilemez. Renk ve beden stokları zaman içinde değişebileceği için ürün sayfasındaki güncel seçenekleri kontrol edebilirsiniz.': 'Out-of-stock options cannot be selected on the product page. As color and size availability changes, please check the current options shown on the product page.',
    'Ürüne özel bakım ve yıkama talimatları için ürün üzerindeki bakım etiketini esas almanızı öneririz. Ürünle ilgili ek bilgiye ihtiyaç duyarsanız müşteri hizmetlerimizden destek alabilirsiniz.': 'For product-specific care and washing instructions, please follow the care label on the item. Contact customer service if you need additional information.',
    'İletişim formumuzu kullanabilir, info@cottonclubrand.com.tr adresine e-posta gönderebilir veya 0 (212) 475 51 25 numaralı telefondan bize ulaşabilirsiniz.': 'You can use our contact form, email info@cottonclubrand.com.tr or call us at 0 (212) 475 51 25.',
    ', günlük giyimde sade tasarımı, rahat kalıpları ve pamuk odaklı kumaş seçeneklerini bir araya getiren bir giyim markasıdır.': ', is a clothing brand that brings together clean design, comfortable fits and cotton-focused fabric options for everyday wear.',
    'Koleksiyonlarımızda': 'Our collections include',
    'tişört, polo yaka ve sweatshirt': 'T-shirts, polo shirts and sweatshirts',
    'modellerinin yanı sıra kadın, erkek ve unisex ürün seçenekleri yer alır. Farklı renk ve kalıp alternatifleriyle günlük kullanıma kolayca uyum sağlayan ürünler sunmayı hedefliyoruz.': 'alongside women, men and unisex options. We aim to offer pieces that fit easily into everyday wear with different colors and fits.',
    'Ürünlerimizi oluştururken': 'When creating our products, we consider',
    'kumaş yapısı, kalıp, renk ve kullanım rahatlığı': 'fabric structure, fit, color and comfort',
    'gibi detayları birlikte değerlendiriyoruz. Koleksiyonlarımızda organik pamuk ve BCI sertifikalı pamuk seçeneklerine de yer vererek farklı ihtiyaçlara uygun alternatifler sunuyoruz.': 'together. Our collections also include organic cotton and BCI certified cotton options to suit different needs.',
    'Cotton Club olarak alışveriş deneyiminin de ürünler kadar sade ve anlaşılır olması gerektiğine inanıyoruz. Ürün bilgileri, ödeme, teslimat ve iade süreçlerinde açık iletişimi ve güvenli alışveriş deneyimini önemsiyoruz.': 'At Cotton Club, we believe the shopping experience should be as clear and straightforward as the products themselves. We value transparent communication and a secure experience across product information, payment, delivery and returns.',
    ', günlük hayatın farklı anlarına uyum sağlayan, rahat ve kullanışlı giyim ürünlerini bir araya getirmeye devam ediyor.': ', continues to bring together comfortable and practical clothing designed for different moments of everyday life.'
  }));

  const regexRules = [
    [
      /^(\d+)\s+değerlendirme$/i,
      (match, count) => `${count} ${Number(count) === 1 ? 'review' : 'reviews'}`
    ],
    [
      /^(\d+)\s+saat\s+(\d+)\s+dakika\s+içinde\s+sipariş\s+verirsen\s+en\s+geç\s+(bugün|yarın)\s+kargoda!$/i,
      (match, hours, minutes, day) => {
        const hourLabel = Number(hours) === 1 ? 'hour' : 'hours';
        const minuteLabel = Number(minutes) === 1 ? 'minute' : 'minutes';
        const shipDay = String(day).toLowerCase() === 'bugün' ? 'today' : 'tomorrow';
        return `Order within ${hours} ${hourLabel} ${minutes} ${minuteLabel} for shipping ${shipDay}!`;
      }
    ],
    [/^(\d+)\s+ürün$/i, '$1 products'],
    [/^(\d+)\s+Ürün$/, '$1 Products'],
    [/^(\d+)\s+Renk$/i, '$1 Colors'],
    [/^%\s*(\d+)\s*İndirim$/i, '$1% Off'],
    [/^(\d+)\s+sütun$/i, '$1 columns'],
    [/^(.+?)'den başlayan$/i, 'From $1'],
    [/^(.+?) ürününü sepete ekle$/i, 'Add $1 to cart'],
    [/^(.+?) ürününü incele$/i, 'View $1'],
    [/^(.+?) bedeni tükendi$/i, '$1 is sold out'],
    [/^(.+?) seçeneği tükendi$/i, '$1 is sold out'],
    [/^(.+?) seçeneğini sepete ekle$/i, 'Add $1 to cart']
  ];

  const normalize = (value) =>
    String(value || '')
      .replace(/\s+/g, ' ')
      .trim();


  /*
    Fallback for newly added product titles that do not yet have a Shopify
    English translation. This runs only on product-title elements and only
    when Turkish catalogue vocabulary is detected.
  */
  const productTitleRules = [
    [/\bBCI Sertifikalı Pamuklu?\b/gi, 'BCI Certified Cotton'],
    [/\bBCI Sertifikalı\b/gi, 'BCI Certified'],
    [/\bOrganik Pamuklu\b/gi, 'Organic Cotton'],
    [/\bOrganik Pamuk\b/gi, 'Organic Cotton'],
    [/\bAplike Logo Detaylı\b/gi, 'Applique Logo Detail'],
    [/\bAplike Logo\b/gi, 'Applique Logo'],
    [/\bBeli Lastikli\b/gi, 'Elastic Waist'],
    [/\bDüz Paça\b/gi, 'Straight Leg'],
    [/\bBisiklet Yaka\b/gi, 'Crew Neck'],
    [/\bPolo Yaka T-?Shirt\b/gi, 'Polo Shirt'],
    [/\bPolo Yaka Tişört\b/gi, 'Polo Shirt'],
    [/\bStandart Kesim\b/gi, 'Standard Fit'],
    [/\bStandart Kalıp\b/gi, 'Standard Fit'],
    [/\bRahat Kalıp\b/gi, 'Relaxed Fit'],
    [/\bOversize Kalıp\b/gi, 'Oversized Fit'],
    [/\bEşofman Altı\b/gi, 'Joggers'],
    [/\bKapüşonlu Sweatshirt\b/gi, 'Hoodie'],
    [/\bNakışlı\b/gi, 'Embroidered'],
    [/\bNakış\b/gi, 'Embroidered'],
    [/\bKontrast\b/gi, 'Contrast'],
    [/\bGünlük\b/gi, 'Everyday'],
    [/\bErkek\b/gi, "Men's"],
    [/\bKadın\b/gi, "Women's"],
    [/\bAçık Mavi\b/gi, 'Light Blue'],
    [/\bKoyu Mavi\b/gi, 'Dark Blue'],
    [/\bLacivert\b/gi, 'Navy'],
    [/\bBeyaz\b/gi, 'White'],
    [/\bSiyah\b/gi, 'Black'],
    [/\bEkru\b/gi, 'Ecru'],
    [/\bBej\b/gi, 'Beige'],
    [/\bHaki\b/gi, 'Khaki'],
    [/\bBordo\b/gi, 'Burgundy'],
    [/\bKırmızı\b/gi, 'Red'],
    [/\bTuruncu\b/gi, 'Orange'],
    [/\bTurkuaz\b/gi, 'Turquoise'],
    [/\bYeşil\b/gi, 'Green'],
    [/\bMavi\b/gi, 'Blue'],
    [/\bGri\b/gi, 'Grey'],
    [/\bKahverengi\b/gi, 'Brown'],
    [/\bTişört\b/gi, 'T-Shirt'],
    [/\bŞort\b/gi, 'Shorts'],
    [/\bPantolon\b/gi, 'Pants'],
    [/\bAtlet\b/gi, 'Tank Top'],
    [/\bTayt\b/gi, 'Leggings'],
    [/\bHırka\b/gi, 'Cardigan'],
    [/\bCeket\b/gi, 'Jacket']
  ];

  const hasTurkishProductVocabulary = (value) =>
    /\b(Erkek|Kadın|Beli Lastikli|Düz Paça|Günlük|Eşofman Altı|Şort|Tişört|Pantolon|Atlet|Tayt|Hırka|Ceket|Nakışlı|Nakış|Organik Pamuk|BCI Sertifikalı|Beyaz|Siyah|Ekru|Lacivert|Mavi|Haki|Bordo|Kırmızı|Turuncu|Turkuaz|Yeşil)\b/i.test(value);

  const translateProductTitle = (value) => {
    let result = normalize(value);
    if (!result || !hasTurkishProductVocabulary(result)) return null;

    productTitleRules.forEach(([pattern, replacement]) => {
      result = result.replace(pattern, replacement);
    });

    return result
      .replace(/\s+/g, ' ')
      .replace(/\s+([–—-])\s+/g, ' $1 ')
      .trim();
  };

  const translate = (value) => {
    const source = normalize(value);

    if (!source) return null;

    if (exact.has(source)) {
      return exact.get(source);
    }

    for (const [pattern, replacement] of regexRules) {
      if (pattern.test(source)) {
        return source.replace(pattern, replacement);
      }
    }

    return null;
  };

  const ignoredParents = new Set([
    'SCRIPT',
    'STYLE',
    'NOSCRIPT',
    'TEXTAREA',
    'CODE',
    'PRE'
  ]);

  const translateTextNode = (node) => {
    if (!node || !node.nodeValue || !node.parentElement) {
      return;
    }

    if (ignoredParents.has(node.parentElement.tagName)) {
      return;
    }

    const original = node.nodeValue;
    const trimmed = original.trim();

    if (!trimmed) return;

    let translated = translate(trimmed);

    if (!translated) {
      const productTitleElement = node.parentElement.closest(
        '.card-product__title, .sk-pdp__title, .sk-pdp__breadcrumb-current'
      );

      if (productTitleElement) {
        translated = translateProductTitle(trimmed);
      }
    }

    if (!translated || translated === trimmed) {
      return;
    }

    const leading =
      original.match(/^\s*/)?.[0] || '';

    const trailing =
      original.match(/\s*$/)?.[0] || '';

    node.nodeValue =
      `${leading}${translated}${trailing}`;
  };

  const translatableAttributes = [
    'aria-label',
    'title',
    'placeholder',
    'data-default-label'
  ];

  const translateAttributes = (element) => {
    if (!(element instanceof Element)) {
      return;
    }

    translatableAttributes.forEach((attribute) => {
      if (!element.hasAttribute(attribute)) {
        return;
      }

      const current =
        element.getAttribute(attribute);

      const translated =
        translate(current);

      if (
        translated &&
        translated !== current
      ) {
        element.setAttribute(
          attribute,
          translated
        );
      }
    });

    if (
      (
        element instanceof HTMLInputElement ||
        element instanceof HTMLButtonElement
      ) &&
      element.value
    ) {
      const translated =
        translate(element.value);

      if (
        translated &&
        translated !== element.value
      ) {
        element.value = translated;
      }
    }
  };

  const translateTree = (root) => {
    if (!root) return;

    if (root.nodeType === Node.TEXT_NODE) {
      translateTextNode(root);
      return;
    }

    if (
      !(root instanceof Element) &&
      root !== document &&
      root !== document.documentElement
    ) {
      return;
    }

    if (root instanceof Element) {
      translateAttributes(root);
    }

    const walker =
      document.createTreeWalker(
        root,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode(node) {
            if (
              !node.parentElement ||
              ignoredParents.has(
                node.parentElement.tagName
              )
            ) {
              return NodeFilter.FILTER_REJECT;
            }

            return NodeFilter.FILTER_ACCEPT;
          }
        }
      );

    let node;

    while (
      (node = walker.nextNode())
    ) {
      translateTextNode(node);
    }

    if (root.querySelectorAll) {
      root
        .querySelectorAll(
          '[aria-label], [title], [placeholder], [data-default-label], input[value], button[value]'
        )
        .forEach(
          translateAttributes
        );
    }
  };

  let queued = false;

  const queueDocumentTranslation = () => {
    if (queued) return;

    queued = true;

    requestAnimationFrame(() => {
      queued = false;

      translateTree(
        document.body ||
        document.documentElement
      );
    });
  };

  if (document.body) {
    translateTree(document.body);
  } else {
    document.addEventListener(
      'DOMContentLoaded',
      () =>
        translateTree(
          document.body
        ),
      {
        once: true
      }
    );
  }

  const observer =
    new MutationObserver(
      (mutations) => {
        let needsFullPass = false;

        mutations.forEach(
          (mutation) => {
            if (
              mutation.type ===
              'characterData'
            ) {
              translateTextNode(
                mutation.target
              );

              return;
            }

            if (
              mutation.type ===
              'attributes'
            ) {
              translateAttributes(
                mutation.target
              );

              return;
            }

            mutation.addedNodes.forEach(
              (node) => {
                if (
                  node.nodeType ===
                  Node.TEXT_NODE
                ) {
                  translateTextNode(node);
                } else if (
                  node.nodeType ===
                  Node.ELEMENT_NODE
                ) {
                  translateTree(node);
                }
              }
            );

            if (
              mutation.addedNodes.length >
              20
            ) {
              needsFullPass = true;
            }
          }
        );

        if (needsFullPass) {
          queueDocumentTranslation();
        }
      }
    );

  observer.observe(
    document.documentElement,
    {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter:
        translatableAttributes
    }
  );

  document.addEventListener(
    'shopify:section:load',
    queueDocumentTranslation
  );

  document.addEventListener(
    'shopify:section:reorder',
    queueDocumentTranslation
  );

  window.addEventListener(
    'load',
    queueDocumentTranslation,
    {
      once: true
    }
  );
})();